import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom"

//services
import {
        auth, 
        generateCookieInfo, 
        generateCookieToken,
        isAuthenticaded
      } from '../../services/Authentication'
import EstructMenuService from '../../services/EstructMenuService'

//layout 
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid'
import AccountCircle from '@material-ui/icons/AccountCircle';
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Hidden from '@material-ui/core/Hidden'
import Alert from '@material-ui/lab/Alert'

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),    
  },
  media: {
    height: 800,
  },
  logo: {
    height: 130,
    width: 130,
    textAlign: 'center',
  },
  formControl:{    
    width:'90%',
    marginLeft: 30,
    marginRight: 30,
    marginBottom: 30,
  },
  inputControl:{
    width:'100%',
  },
  title:{
    textAlign: 'center',
    marginBottom: 50,
    display:'flex',    
    justifyContent: 'center',
  },
}));


export default (props) => {

  const classes = useStyles()
  const history = useHistory()  

  const [username, setUsername] = React.useState("")
  const [password, setPassword] = React.useState("")
  const [status, setStatus] = React.useState({code:'', msg: ''})
  const isAuth = isAuthenticaded()


  const sendToAnotherPage = () => {
    history.push(`/`)   
    window.location.reload()   
  }

  const handlerAuth = () => {            
    auth(username, password)
      .then(resp => {                             
        if(resp?.response?.status === 403){
          setStatus({
            code: 403,
            msg: 'Usuário ou senha inválido'
          })
        } else {
          setStatus({code:resp.status, msg:''})          
          loadInfo(resp.headers.authorization)
        }
        
      })
      .catch( (error) =>{        
        console.error('(1) Inside error:', error)
      } )   
  }

  const loadInfo = (authorization) => {
    const response = EstructMenuService.infoByToken(authorization)
    response.then(resp => {                   
      generateCookieInfo(resp.data)
      generateCookieToken(authorization) 
      sendToAnotherPage()
    })    
    .catch(error => {
      console.error(console.error())
    })
  }

  const handlerUsername = (event) =>{
    setUsername(event.target.value)
  }

  const handlerPassword = (event) =>{
    setPassword(event.target.value)
  }

  return (
    <div>    

       {isAuth ? (sendToAnotherPage()):''}

       <Card className={classes.root} variant="outlined">                        
          <Grid container spacing={1} alignItems="center">
          <Hidden only={[ 'md']}>  
            <Grid md={6} >
              <CardMedia       
                  className={classes.media}      
                  image={process.env.PUBLIC_URL + "/img/layou-login-left.png"}
                  title="TDS Dashboard"
                />
            </Grid>
          </Hidden>
          <Grid item xs={12} md={6}
                  direction="column"
                  alignItems="center" 
                  justify="center" >

              <Hidden only={['md', 'lg', 'sm']}>  
                <Grid item className={classes.title} >
                  <CardMedia        
                  className={classes.logo}                       
                    image={process.env.PUBLIC_URL + "/logo192.png"}
                    title="TDS Dashboard"
                  />
                </Grid>
              </Hidden>
            <div>
              <FormControl className={classes.formControl}>
                <InputLabel>Seu usuário</InputLabel>
                <Input                  
                  onChange={handlerUsername}
                  startAdornment={
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <div>
              
              <FormControl className={classes.formControl} >
                <InputLabel>Sua senha</InputLabel>
                <Input                
                  className={classes.inputControl}
                  type="password"
                  onChange={handlerPassword}
                  startAdornment={
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  }
                />
            </FormControl>
            </div>     

            <div>                 
              <Button className={classes.formControl} variant="contained" color="primary" onClick={handlerAuth} >Acessar</Button>              
            </div>

            <div>    
            {status.msg?(
              <Grid item xs={12} className={classes.formControl}  >
                <Alert severity="error"><strong>[{status.code}]</strong> {status.msg}</Alert>
              </Grid>  
            ):('')}              
            </div>
          </Grid>

        </Grid>          
        </Card>
        
      </div>
  )

}